export default __webpack_public_path__ + "static/JetsPizza-0d0488c8fe25a93b79ffa513c0fec62c.png";